import React, { Component, Fragment } from "react";
import { useEffect } from "react";
import { useState } from "react";
import { NavLink } from "react-router-dom";


const Navbar = (props) => {
  const [toogleMenu, setToogleMenu] = useState(false)

  return (
    <Fragment>

      <div className={"wrapper__side-nav-mobile d-flex d-xl-none " + (toogleMenu ? "active" : "")}>
        <div className="d-flex flex-wrap w-100">
          <div className="w-100">
            <div className="position-relative mb-4">
              <img src="./../images/clsoe2.png" onClick={() => setToogleMenu(!toogleMenu)} className="pointer" alt="" />
              <NavLink
                to="/"
                exact
                class="navbar-brand font__size--20 normal color__white wrapper__center-nav"
              >
                MOMENTS
              </NavLink>
            </div>
            <div className="menu text-center">
              <NavLink to="/" className="medium font__size--16 color__white play">Home</NavLink>
              <hr />
              <NavLink to="/plan" className="medium font__size--16 color__white play">Plan</NavLink>
              <hr />
              <NavLink
                to="/service" className="medium font__size--16 color__white play">Services</NavLink>
              <hr />
              <NavLink to="/album" className="medium font__size--16 color__white play">Albums</NavLink>
              <hr />
              <NavLink to="/portofolio" className="medium font__size--16 color__white play">Portofolio</NavLink>
              <hr />
              <NavLink to="/contact" className="medium font__size--16 color__white play">Contact Us</NavLink>
              <hr />
              <NavLink to="/book-now" className="medium font__size--14 btn btn__outlined--darkgreen color__darkgreen shadow text-capitalize rounded__50 h__white no__opacity pointer" >Book Now</NavLink>
            </div>
          </div>
        </div>
      </div >
      <nav
        className="navbar navbar-expand-xl wrapper__navbar position-relative z-2"
        data-aos="fade-down"
        data-aos-duration="1000"
        data-aos-delay="300"
      >
        <div className="container position-relative">
          <NavLink
            to="/"
            exact
            class={"navbar-brand font__size--18 text__18-1024 normal " + (props.type == "dark" ? "color__black" : "color__white")}
          >
            MOMENTS
          </NavLink>

          <div
            className="collapse navbar-collapse wrapper__navbar-menu ml-lg-5"
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav menu__center">
              <li className="nav-item">
                <NavLink
                  to="/"
                  class={"nav-link normal font__size--16 text__16-1024 text-uppercase hover " + (props.type == "dark" ? "color__black" : "color__white")}
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/plan"
                  class={"nav-link normal font__size--16 text__16-1024 text-uppercase hover " + (props.type == "dark" ? "color__black" : "color__white")}
                >
                  Plan
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/service"
                  class={"nav-link normal font__size--16 text__16-1024 text-uppercase hover " + (props.type == "dark" ? "color__black" : "color__white")}
                >
                  SERVICES
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/album"
                  class={"nav-link normal font__size--16 text__16-1024 text-uppercase hover " + (props.type == "dark" ? "color__black" : "color__white")}
                >
                  ALBUMS
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/portofolio"
                  class={"nav-link normal font__size--16 text__16-1024 text-uppercase hover " + (props.type == "dark" ? "color__black" : "color__white")}
                >
                  portofolio
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/contact"
                  class={"nav-link normal font__size--16 text__16-1024 text-uppercase hover " + (props.type == "dark" ? "color__black" : "color__white")}
                >
                  CONTACT US
                </NavLink>
              </li>
            </ul>
          </div>


          <div className={"wrapper__menu-wrap ml-auto flex-shrink-0 d-flex align-items-center d-xl-none " + (props.type == "dark" ? "dark" : "")}>
            <h5 className="mb-0 medium mr-2 color__white font__size--16 text__16-1024">
              Menu
            </h5>
            <div
              onClick={() => setToogleMenu(!toogleMenu)}
              class="nav__button position-relative"
            >
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
          <NavLink to="/book-now" className={"d-none d-xl-block medium font__size--14 text__14-1024 btn shadow ml-auto text-uppercase rounded__50  no__opacity pointer " + (props.type == "dark" ? "btn__darkgreen color__white" : "btn__outlined--white color__white h__black")} >Book Now</NavLink>
        </div>
      </nav>
    </Fragment >
  );
};

export default Navbar;
